module.exports = __webpack_public_path__ + "img/laborConditions.1ce4d0ac.svg";